/** Shared WooCommerce wc-auth URL builder for CRM flows. */

const normalizeShopOrigin = (shopUrl: string): string => {
  let normalizedUrl = shopUrl.trim();
  if (!normalizedUrl.startsWith('http://') && !normalizedUrl.startsWith('https://')) {
    normalizedUrl = `https://${normalizedUrl}`;
  }
  return new URL(normalizedUrl).origin;
};

export const buildWooCommerceOAuthUrls = (params: {
  shopUrl: string;
  accountId: string;
  storeId: string;
  targetReturnUrl: string;
  callbackBaseUrl: string;
  apiBaseUrl: string;
  appName?: string;
}): { authUrl: string; attempt: string } => {
  const normalizedUrl = normalizeShopOrigin(params.shopUrl);
  const attempt = crypto.randomUUID();
  const userIdPayload = JSON.stringify({
    accountId: params.accountId,
    storeId: params.storeId,
  });
  const encodedUserId = btoa(userIdPayload);
  const returnBridge = `${params.apiBaseUrl}/api/public/oauth/woocommerce/return?attempt=${encodeURIComponent(attempt)}&target=${encodeURIComponent(params.targetReturnUrl)}`;
  const callbackUrl = `${params.callbackBaseUrl}/api/public/oauth/woocommerce/callback?store_url=${encodeURIComponent(normalizedUrl)}&attempt=${encodeURIComponent(attempt)}`;
  const authUrl = new URL(`${normalizedUrl}/wc-auth/v1/authorize`);

  authUrl.searchParams.set('app_name', params.appName ?? 'TagadaPay');
  authUrl.searchParams.set('scope', 'read_write');
  authUrl.searchParams.set('user_id', encodedUserId);
  authUrl.searchParams.set('return_url', returnBridge);
  authUrl.searchParams.set('callback_url', callbackUrl);

  return { authUrl: authUrl.toString(), attempt };
};
